import React from "react";
import { Link } from "react-router-dom/dist";

function Landing ()
{
    localStorage.clear()
    return (
        <div className="w-full">
   

        <div className="w-full flex flex-col text h-screen items-center justify-center">

       <div className="mb-5"><h1 className="font-bold text-2xl" style={{fontFamily: "Kaushan Script"}} >MyKura</h1> </div>
       <div className="mb-5">
            <p className="text-lg px-10">Sign up to vote <span style={ {color: "red"}}>fast </span> and</p>
            <p className="text-lg px-10"><span style={ {color: "red"}}>securely</span> for your future.</p>
         </div>
            <div className="mb-5">  <button className="bg-[#0CF84E]  text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline text-center"> <Link to="https://www.myvotemykura.co.ke/">Go to mykura's webpage </Link></button> </div>
            <div className="flex-row">
            <Link className="text-[#0CF84E] cursor-pointer" to="/sign-in">Log in</Link> or <Link className="text-[#0CF84E] cursor-pointer" to="/sign-up">sign up</Link>
            </div>
        </div>
        <div className="items-center flex flex-col pb-2">
            <p>
                From                
            </p>
            <br /> 
            <img src="myKura.png" alt="mykura logo" />
        </div>
        </div>
    )

}

export default Landing;